function hideReviews(containerReviews, getNumber, closestSelector) {
    containerReviews.forEach((container) => {
      const firstSpan = container.querySelector(getNumber);
  
      if (!firstSpan) return;
  
      const spanText = firstSpan.textContent.trim();
      const numberMatch = spanText.match(/\d+/);
  
      if (numberMatch && parseInt(numberMatch[0]) < 10) {
        container.closest(closestSelector).style.display = "none";
      }
    });
  }
  
  function validateReviews() {

    // HOME PAGE - PLP
    const reviews = document.querySelectorAll(
      "#ReviewsOkendo .okeReviews-reviewsSummary-ratingCount"
    );
    const reviews2 = document.querySelectorAll(
      ".rating .okeReviews-reviewsSummary-ratingCount"
    );

    // PDP

    const pdp = document.querySelectorAll(
        ".okeReviews.okeReviews--theme"
    )

    // HOME PAGE - PLP
    hideReviews(reviews, "span:first-child", "#ReviewsOkendo");
    hideReviews(reviews2, "span:first-child", ".rating");

    // PDP
    hideReviews(pdp, '.okeReviews-reviewsSummary-ratingCount', ".okeReviews--theme")

}
  
  validateReviews();
  
  const targetNode = document.querySelector(".boost-pfs-filter-right-col"); 
  const config = { childList: true, subtree: true };
  
  const observer = new MutationObserver(() => {
    validateReviews();
  });
  
  if (targetNode) {
    observer.observe(targetNode, config);
  }


